export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10468.9e11090a.jpg";